import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit_small",
  "use": "edit_small-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"edit_small\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.66 0c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41L15.37.29c-.2-.2-.45-.29-.71-.29Zm-3.6 6.02.92.92L2.92 16H2v-.92l9.06-9.06ZM0 14.25 11.06 3.19l3.75 3.75L3.75 18H0v-3.75Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol